export default __webpack_public_path__ + "static/4-f1931850621111aa13ea31d1ef90f095.png";